export default __webpack_public_path__ + "static/analytics_image_small-e5b3471edb1724e7afea2eeb586f2f12.webp";